import React from "react";
import iconMap from "src/assets/icons/Icons";
import BarcodeComponent from "src/shared/components/barcode/BarcodeComponent";
import BarcodeScanner from "src/shared/components/barcode/BarcodeScanner";

type Props = {
  barcodeId: string;
  barcodeMode: boolean;
  scanMode: boolean;
  onToggleScan: () => void;
  onDetected: (code: string) => void;
};

export default function BarcodeSection({ barcodeId, barcodeMode, scanMode, onToggleScan, onDetected }: Props) {
  const Icon = iconMap["BarcodeReaderIcon"];
  return (
    <div className="text-center w-full">
      <div onClick={onToggleScan} className="flex justify-center items-center gap-2 bg-gray-200 px-3 py-1 rounded-md cursor-pointer">
        <Icon /> <span>Add or Create Barcode</span>
      </div>
      {barcodeMode && (
        <div className="my-2 flex justify-center">
          <BarcodeComponent value={barcodeId} width={1.5} height={20} />
        </div>
      )}
      {scanMode && <BarcodeScanner onDetected={onDetected} />}
    </div>
  );
}
